"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.savedLocationDeserialize = void 0;
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const Location_1 = require("./Location");
function savedLocationDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value);
    return Object.assign({ id: (0, deserializeString_1.deserializeString)(id), uid: (0, deserializeString_1.deserializeString)(object.uid) }, (0, Location_1.locationDeserialize)(value));
}
exports.savedLocationDeserialize = savedLocationDeserialize;
